/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespModuleItemTile_linkData = {
    readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    readonly " $refType": "HpRespModuleItemTile_linkData";
};
export type HpRespModuleItemTile_linkData$data = HpRespModuleItemTile_linkData;
export type HpRespModuleItemTile_linkData$key = {
    readonly " $data"?: HpRespModuleItemTile_linkData$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespModuleItemTile_linkData">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespModuleItemTile_linkData",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeoLink_linkData"
    }
  ],
  "type": "LinkData",
  "abstractKey": null
};
(node as any).hash = '03e84da571de9db5f6c3c83ae4bf28fb';
export default node;
